import { render } from "./initializedDeliveryOrdersActionMenu.vue?vue&type=template&id=14331558&scoped=true"
import script from "./initializedDeliveryOrdersActionMenu.vue?vue&type=script&lang=js"
export * from "./initializedDeliveryOrdersActionMenu.vue?vue&type=script&lang=js"

import "./initializedDeliveryOrdersActionMenu.vue?vue&type=style&index=0&id=14331558&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14331558"]])

export default __exports__